import { Box, Button, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { BreadCrumb, SnackSimple } from "../../../../../../components";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useBody } from "./hooks/body";
import { CustomePanel, CustomeTab } from "../../../../../../components/customeTab";
import { TabsItemGroup } from "../../utils/enums/tabs";
import { useMemo } from "react";
import { PageOptionGroup } from "../../utils/enums/page";
import { CustomPaper } from "../../../../../../components/CustomPaper";
import { InterUserTable } from "./components/internalUser";
import { InterUserSelected } from "./components/userSelected";
import { ExternalUser } from "./components/externalUser";
import SimpleModal from "../../../../../../components/modal/simpleModal";
import { icons } from "../../../../../../utils/icons";
import { LoadingButton } from "@mui/lab";
import { InternalDetail } from "./components/internalDetail";
import Loader from "../../../../../../components/loader";


export const UserGroupForm = () => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { id } = useParams()
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const from = searchParams.get("from");
    const mode: PageOptionGroup = useMemo(() => {
        if (pathname.includes("detail")) return PageOptionGroup.DETAIL;
        if (pathname.includes("edit")) return PageOptionGroup.EDIT;
        return PageOptionGroup.CREATE;
    }, [pathname,from]);
    const body = useBody({ id, from, mode });


    return (
        <Box sx={styles.container}>
            <SnackSimple close={body.closeSnackbar} message={body.snackbar.message} open={body.snackbar.open} type={body.snackbar.type} />
            <BreadCrumb breadList={body.listBreadCrumb} removeBreadcrumb={['user']} replaceLabels={{ create: 'createGroup', edit: 'editGroup' }} />

            {body.loaderDetail ?
                <Loader />
                :
                <Box sx={styles.body}>
                    <Box sx={styles.containerTitle}>
                        <Typography variant="title_blue" className="title">{t(`userGroup.titles.form.${mode}`)}</Typography>

                        {mode == PageOptionGroup.DETAIL &&
                            <Box sx={styles.iconContainer}>
                                <Tooltip title={t('ToolTips.edit')}>
                                    <IconButton onClick={body.goToEdit} sx={styles.edit}>{icons('edit')}</IconButton>
                                </Tooltip>

                                <Tooltip title={t('ToolTips.delete')}>
                                    <IconButton onClick={body.handleDelete} sx={styles.delete}>{icons('delete')}</IconButton>
                                </Tooltip>
                            </Box>
                        }
                    </Box>

                    <Box sx={styles.nameContainer}>
                        {mode !== PageOptionGroup.DETAIL && <Typography fontWeight={'bold'}>{t('userGroup.titles.groupName')}</Typography>}

                        {mode == PageOptionGroup.DETAIL ?
                            <Typography variant="title_grey">{body.valueVame}</Typography>
                            :
                            <Grid container>
                                <Grid item xs={5}>
                                    <TextField
                                        name="nameUserGroup"
                                        label={t('userGroup.inputs.title.nameGroup')}
                                        value={body.valueVame}
                                        onChange={body.handleChange}
                                        onBlur={body.handleBlur}
                                        required
                                        error={Boolean(body.errors.name)}
                                        helperText={
                                            body.errors.name === "required"
                                                ? t("userGroup.inputs.error.nameRequired")
                                                : body.errors.name === "minLength"
                                                    ? t("userGroup.inputs.error.nameMinLength", { min: 3 })
                                                    : ""
                                        }
                                        inputProps={{ maxLength: 255 }}
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Box>

                    <Box>
                        <CustomeTab
                            listTab={body.tabs}
                            value={body.tabValue}
                            justifyContent="start"
                            tabList={{ onChange: (_, value) => { body.changeTab({ value }) } }}
                            endChildrenTab={
                                body.tabValue === TabsItemGroup.INTERNAL_USER ? (
                                    <Typography sx={styles.counter(mode == PageOptionGroup.DETAIL ? body.totalSelected : body.usersSelected.length)}>{t('userGroup.text.countUsersSelected', { count: mode == PageOptionGroup.DETAIL ? body.totalSelected : body.usersSelected.length })}</Typography>
                                ) : null
                            }
                        >
                            <CustomePanel sx={styles.tabs} value={TabsItemGroup.INTERNAL_USER}>
                                {mode == PageOptionGroup.DETAIL ?
                                    <InternalDetail
                                        filterUserInternal={body.filterUserInternal}
                                        isLoading={body.isLoading}
                                        row={body.rowDetail}
                                        totalPages={body.totalPages}
                                    />
                                    :
                                    <Grid container spacing={3}>
                                        <Grid item xl={8} lg={6.5} md={12} sm={12} xs={12}>
                                            <CustomPaper elevation={3} sx={styles.paper}>
                                                <InterUserTable
                                                    createFilter={body.createFilterMemo}
                                                    input={body.inputMemo}
                                                    searchUsers={body.searchUsers}
                                                    handleSelects={body.handleSelects}
                                                    row={body.rowMemo}
                                                    selects={body.selectsMemo}
                                                    loadingTable={body.loadingTable}
                                                    handleAddUser={body.handleAddUser}
                                                />
                                            </CustomPaper>
                                        </Grid>

                                        <Grid item xl={4} lg={5.5} md={12} sm={12} xs={12}>
                                            <CustomPaper elevation={3} sx={styles.paper}>
                                                <InterUserSelected
                                                    loading={body.isLoading}
                                                    deleteAllUser={mode == PageOptionGroup.EDIT ? body.deleteAllUser : undefined}
                                                    deleteUser={mode == PageOptionGroup.CREATE ? body.deleteUser : undefined}
                                                    usersSelected={body.usersSelected}
                                                    mode={mode}
                                                />
                                            </CustomPaper>
                                        </Grid>
                                    </Grid>
                                }

                            </CustomePanel>
                            <CustomePanel sx={styles.tabs} value={TabsItemGroup.EXTERNAL_USER}>
                                <ExternalUser mode={mode} emails={body.emails} setEmails={body.setEmails} errors={body.errorsEmail} setErrors={body.setErrorsEmail} />
                            </CustomePanel>
                        </CustomeTab>
                    </Box>

                    {mode !== PageOptionGroup.DETAIL &&
                        <Box sx={styles.containerButtons}>
                            <Button onClick={body.handleBack}>{t('general.cancel')}</Button>
                            <LoadingButton loading={body.submitLoader} disabled={ body.valueVame.trim().length < 3 || !body.usersSelected.length || !!body.errorsEmail.length} onClick={body.handleSubmit} variant="contained">{t(`general.${id ? 'edit' : 'save'}`)}</LoadingButton>
                        </Box>
                    }
                </Box>
            }

            <SimpleModal
                open={body.modal.open}
                close={() => { body.closeModal() }}
                removeClose={!body.modal?.cancel}
                title={body.modal.title}
                description={body.modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={body.modal?.cancel ?? undefined}
                next={body.modal.confirm ?? body.closeModal}
                loadingButton
                isLoading={body.modal.loader}
            />
        </Box>
    )
}